<template>
  <div class="create-route-card">
    <span class="title">Create Route</span>
    <div class="tab-container">
      <ThemedTapBar :tabs="items" v-model="tab" @change="onTabChanged" />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="onAddRouteButtonPressed()"
          >
            <v-icon color="var(--color-secondary)"
              >mdi-plus-circle-outline</v-icon
            >
          </v-btn>
        </template>
        <span>Go to create route</span>
      </v-tooltip>
    </div>

    <v-tabs-items v-model="tab" class="tab-items">
      <v-tab-item>
        <CreateRouteManuallyComponent />
      </v-tab-item>
      <v-tab-item>
        <SelectExistingRouteComponent />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CreateRouteManuallyComponent from "./CreateRouteManually.vue";
import SelectExistingRouteComponent from "./SelectExistingRoute.vue";
import ThemedTapBar from "@/core/ThemedTapBar.vue";
export default {
  components: {
    CreateRouteManuallyComponent,
    SelectExistingRouteComponent,
    ThemedTapBar,
  },
  data() {
    return {
      tab: null,
      items: ["Vessel position/nearest port", "From existing route"],
    };
  },
  methods: {
    onAddRouteButtonPressed() {
      this.$router.push({
        name: "Create Route",
      });
      this.$store.commit(
        "weatherRouting/routesModule/SET_SELECTED_ROUTE",
        null
      );
    },
    onTabChanged(tab) {
      if (tab == 0) {
        this.$store.commit(
          "weatherRouting/formModule/SET_USE_SELECTED_ROUTE",
          false,
          { root: true }
        );
        this.$store.commit(
          "weatherRouting/routesModule/SET_SELECTED_ROUTE",
          null
        );
        this.$store.commit(
          "weatherRouting/formModule/SET_SELECTED_ROUTE",
          null,
          { root: true }
        );
      } else {
        this.$store.commit(
          "weatherRouting/formModule/SET_USE_SELECTED_ROUTE",
          true,
          { root: true }
        );
      }
    },
  },
};
</script>

<style scoped>
.create-route-card {
  width: 100%;
  background-color: var(--color-bg);
  border-radius: 10px;
  border: 1px solid var(--color-secondary);
  padding: 10px;
}
.title {
  color: var(--color-text);
}
.divider {
  background-color: var(--color-text);
}
.content-container {
  background-color: var(--color-bg);
  padding: 10px;
}
.tab-container {
  background-color: var(--color-bg);
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tab-items {
  background-color: transparent !important;
}
</style>

